import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
    selector: 'itpx-expansion-panel',
    templateUrl: './expansion-panel.component.html',
    styleUrls: ['./expansion-panel.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpansionPanelComponent {

    @Input() expanded: boolean = false;

    togglePanel() {
        this.expanded = !this.expanded;
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/components/expansion-panel/expansion-panel.component.ts